import {
  Button,
  Container,
  Dialog,
  Grid,
  Paper,
  Stack,
  Typography,
  Box,
  TextField as MuiTextField
} from '@mui/material';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BILLING_TYPE_REPORT } from '../../../../../constants/dropdown';
import { SelectDoctorTable } from '../masters/others/SelectDoctorTable';
import axios from 'axios';

const validationSchema = Yup.object().shape({
  from_date: Yup.string().required('From date is required'),
  to_date: Yup.string().required('To date is required')
});

const SERVICE_HEADER = [{ header: 'Service Name', accessor: (row) => row?.service_name }].filter(Boolean);
const GROUP_HEADER = [{ header: 'Group Name', accessor: (row) => row?.groupname }].filter(Boolean);
const SUBGROUP_HEADER = [{ header: 'Sub Group Name', accessor: (row) => row?.subgroupname }].filter(Boolean);

export const ServiceRegisterReport = () => {
  const { pathname } = useLocation();
  const [groupDropdown, setGroupDropdown] = useState([]);
  const [subGroupDropdown, setSubGroupDropdown] = useState([]);
  const [serviceDropdown, setServiceDropdown] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [input, setInput] = useState('');
  const [serviceIds, setServiceIds] = useState([]);
  const [groupIds, setGroupIds] = useState([]);
  const [subGroupIds, setSubGroupIds] = useState('');
  const [selectedService, setSelectedService] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [selectedSubGroup, setSelectedSubGroup] = useState([]);
  const [groupInput, setGroupInput] = useState('');
  const [subgroupInput, setSubGroupInput] = useState('');

  const user = JSON.parse(localStorage.getItem('user'));
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
      group: '',
      subgroup: '',
      service: ''
    },
    mode: 'all'
  });

  const { watch } = methods;

  const getServiceDropdownData = async () => {
    const data = await axios.get(`${BASE_URL}/service-bysubgroup/list?sub_group=${subGroupIds}`);
    setServiceDropdown(data.data);
  };

  useEffect(() => {
    if (subGroupIds) {
      getServiceDropdownData();
    }
  }, [subGroupIds]);

  const getGroupDropdownData = useCallback(async () => {
    const data = await dropdownFetch('group-master');
    setGroupDropdown(data);
  }, []);

  const getSubGroupDropdownData = useCallback(async () => {
    const data = await axios.get(`${BASE_URL}/subgroup-master-bygroup/list?groupname=${groupIds}`);
    setSubGroupDropdown(data);
  }, [groupIds]);

  useEffect(() => {
    if(groupIds.length > 0){
    getSubGroupDropdownData();
    }
  }, [getSubGroupDropdownData]);

  useEffect(() => {
    getGroupDropdownData();
  }, []);

  const isServiceSelected = (row, field) => {
    if (!Array.isArray(selectedService)) {
      return false;
    }
    const selectedRow = selectedService.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowServiceSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedService)) {
      setSelectedService([]);
      return;
    }
    setSelectedService((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const isGroupSelected = (row, field) => {
    if (!Array.isArray(selectedGroup)) {
      return false;
    }
    const selectedRow = selectedGroup.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowGroupSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedGroup)) {
      setSelectedGroup([]);
      return;
    }
    setSelectedGroup((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const isSubGroupSelected = (row, field) => {
    if (!Array.isArray(selectedSubGroup)) {
      return false;
    }
    const selectedRow = selectedSubGroup.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSubGroupSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedSubGroup)) {
      setSelectedSubGroup([]);
      return;
    }
    setSelectedSubGroup((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const handleGroupChange = (e) => {
    setGroupInput(e.target.value);
  };

  const handleSubGroupChange = (e) => {
    setSubGroupInput(e.target.value);
  };

  const getSearchService = async () => {
    const lowercasedInput = input.toLowerCase();
    try {
      const response = await axios.get(
        `${BASE_URL}/service-bysubgroup/list?sub_group=${subGroupIds}&service_name=${lowercasedInput}&limit=10`
      );
      setServiceDropdown(response.data);
    } catch (error) {
      console.error('Error fetching service data:', error);
    }
  };

  const getSearchGroup = async () => {
    const lowercasedInput = groupInput.toLowerCase();
    try {
      const response = await axios.get(`${BASE_URL}/group-master/list?groupname=${lowercasedInput}`);
      setGroupDropdown(response.data.data);
    } catch (error) {
      console.error('Error fetching service data:', error);
    }
  };

  const getSearchSubGroup = async () => {
    const lowercasedInput = subgroupInput.toLowerCase();
    const data = await axios.get(
      `${BASE_URL}/subgroup-master-bygroup/list?groupname=${groupIds}&subgroupname=${lowercasedInput}`
    );
    setSubGroupDropdown(data);
  };

  useEffect(() => {
    if (subgroupInput && groupIds) {
      getSearchSubGroup();
    }
  }, [subgroupInput, groupIds]);

  useEffect(() => {
    getSearchGroup();
  }, [groupInput]);

  useEffect(() => {
    if (input && subGroupIds) {
      getSearchService();
    }
  }, [input, subGroupIds]);

  useEffect(() => {
    const ids = selectedService.map((item) => item._id).join(',');
    setServiceIds(ids);
  }, [selectedService]);

  useEffect(() => {
    const ids = selectedGroup.map((item) => item._id).join(',');
    setGroupIds(ids);
  }, [selectedGroup]);

  useEffect(() => {
    const ids = selectedSubGroup.map((item) => item._id).join(',');
    setSubGroupIds(ids);
  }, [selectedSubGroup]);

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Service Register Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('to_date') || !watch('to_date')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({
                        from_date: watch('from_date'),
                        to_date: watch('to_date'),
                        group: groupIds,
                        subgroup: subGroupIds,
                        service: serviceIds,
                        billing_type: watch('billing_type')
                      })}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.4 }} name="from_date" type="date" />
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.4 }} name="to_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.23, fontWeight: 700, fontSize: '1.4rem' }}>Billing Type</Typography>
                    <SelectTag formControlSX={{ flex: 0.8 }} name="billing_type" menus={BILLING_TYPE_REPORT} />
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 2,
                width: '100%',
                overflowX: 'auto',
                marginTop: '2%'
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 1 }}>
                <MuiTextField
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      padding: '0',
                      fontSize: '1.4rem'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 1.4rem'
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '1.2rem'
                    }
                  }}
                  label="Search By Group Name"
                  variant="outlined"
                  value={groupInput}
                  onChange={handleGroupChange}
                />
                <SelectDoctorTable
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={groupDropdown || []}
                  columns={GROUP_HEADER}
                  size="small"
                  showInputField={true}
                  showOk={true}
                  isSelected={isGroupSelected}
                  handleRowSelect={handleRowGroupSelect}
                  currentAction={'new'}
                  selectedRows={selectedRows}
                />
              </Box>

              {/* SubGroup table */}
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 1 }}>
                <MuiTextField
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      padding: '0',
                      fontSize: '1.4rem'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 1.4rem'
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '1.2rem'
                    }
                  }}
                  label="Search By Sub Group Name"
                  variant="outlined"
                  value={subgroupInput}
                  onChange={handleSubGroupChange}
                />
                <SelectDoctorTable
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={subGroupDropdown?.data?.data || []}
                  columns={SUBGROUP_HEADER}
                  size="small"
                  showInputField={true}
                  showOk={true}
                  isSelected={isSubGroupSelected}
                  handleRowSelect={handleRowSubGroupSelect}
                  currentAction={'new'}
                  selectedRows={selectedRows}
                />
              </Box>
              {/* Column container for Search field and first table */}
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 1 }}>
                <MuiTextField
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      padding: '0',
                      fontSize: '1.4rem'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 1.4rem'
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '1.2rem'
                    }
                  }}
                  label="Search By Service Name"
                  variant="outlined"
                  value={input}
                  onChange={handleChange}
                />
                <SelectDoctorTable
                  containerSX={{ border: '1px solid rgba(0,0,0,0.27)', flex: 1 }}
                  data={serviceDropdown.data || []}
                  columns={SERVICE_HEADER}
                  size="small"
                  showInputField={true}
                  showOk={true}
                  isSelected={isServiceSelected}
                  handleRowSelect={handleRowServiceSelect}
                  currentAction={'new'}
                  selectedRows={selectedRows}
                />
              </Box>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};

export default ServiceRegisterReport;
